import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: {
            fbUser: {
                uid: '',
                displayName: '',
                email: '',
                emailVerified: ''
            },
            employee: ''
        },
        isAuthenticated: false,
        locations: [],
        employees: [],
        internalApi: {
            locationApi: 'https://hydraportal.app/api/location',
            employeeApi: 'https://hydraportal.app/api/employee',
            sendMailApi: 'https://hydraportal.app/api/mail'
        }
    },
    mutations,
    actions,
    getters
});
